import React from 'react';
import type { BatchProgress } from './types';

export const BatchProcessingPanel: React.FC<{
  batchSize: number;
  onBatchSizeChange: (size: number) => void;
  onStartBatch: () => void;
  onStopBatch: () => void;
  batchProgress: BatchProgress | null;
}> = ({ batchSize, onBatchSizeChange, onStartBatch, onStopBatch, batchProgress }) => (
  <div className="dvc-batch-processing">
    <h3>Batch Processing</h3>
    <div className="dvc-form-group">
      <label htmlFor="batchSize">Batch Size:</label>
      <input
        type="number"
        id="batchSize"
        min={1}
        max={100}
        value={batchSize}
        onChange={(e) => onBatchSizeChange(parseInt(e.target.value, 10))}
      />
    </div>
    <div className="dvc-button-group">
      <button type="button" onClick={onStartBatch}>
        Start Batch Processing
      </button>
      <button type="button" onClick={onStopBatch} className="dvc-stop-button">
        Stop Processing
      </button>
    </div>

    {batchProgress && (
      <div className="dvc-batch-progress">
        <h4>Progress</h4>
        <div className="dvc-progress-info">
          <div>
            <strong>Status:</strong> {batchProgress.status}
          </div>
          <div>
            <strong>Download Progress:</strong> {batchProgress.download_percentage.toFixed(1)}%
            <div className="dvc-progress-bar">
              <div
                className="dvc-progress-bar-fill"
                style={{ width: `${batchProgress.download_percentage}%` }}
              />
            </div>
          </div>
          <div>
            <strong>Processing Progress:</strong> {batchProgress.inference_percentage.toFixed(1)}%
            <div className="dvc-progress-bar">
              <div
                className="dvc-progress-bar-fill dvc-inference"
                style={{ width: `${batchProgress.inference_percentage}%` }}
              />
            </div>
          </div>
          <div>
            <strong>Current Image:</strong>{' '}
            <span className="dvc-current-image">{batchProgress.current_image || '-'}</span>
          </div>
          <div>
            <strong>Elapsed Time:</strong> {Math.round(batchProgress.elapsed_time)}s
          </div>
          <div>
            <strong>Results:</strong> {batchProgress.inference_completed} completed,{' '}
            {batchProgress.failed_inferences} failed
          </div>
        </div>
      </div>
    )}
  </div>
);
